import { POST } from '@wellsfargo/ecpfs-authority'

export const E_SIGN_CONSENT_PATH = 'register/agreement/text.json'

export function fetchEsignConsent(payload) {
	return POST(E_SIGN_CONSENT_PATH, payload)
}
